var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "news-container" }, [
    _c("div", { staticClass: "content-full-width flex" }, [
      _c(
        "button",
        {
          staticClass: "button small button-filter",
          class: { active: _vm.toggleFilter },
          on: {
            click: function($event) {
              _vm.toggleFilter = !_vm.toggleFilter
            }
          }
        },
        [
          _vm.toggleFilter ? _c("span", [_vm._v("HIDE")]) : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v("FILTERS")])
        ]
      ),
      _vm._v(" "),
      _c(
        "aside",
        { staticClass: "filter-sidebar", class: { active: _vm.toggleFilter } },
        [
          _c("div", { staticClass: "category" }, [
            _c(
              "div",
              { staticClass: "archive" },
              [
                _c("label", [_vm._v("Archive")]),
                _vm._v(" "),
                _vm._l(_vm.archives, function(link, index) {
                  return index < _vm.archiveShow
                    ? _c("a", { key: index, attrs: { href: link.url } }, [
                        _vm._v("\n              " + _vm._s(link.label) + " "),
                        _c("span", [_vm._v("(" + _vm._s(link.count) + ")")])
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.archives.length > _vm.archiveShow
                  ? _c(
                      "button",
                      {
                        staticClass: "toggle",
                        on: {
                          click: function($event) {
                            _vm.archiveShow = _vm.archives.length
                          }
                        }
                      },
                      [_vm._v("\n              Show More\n          ")]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "news-list" }, [
        _c("div", { staticClass: "form-field text search" }, [
          _c("label", [_vm._v("Search")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.payload.keyword,
                expression: "payload.keyword"
              },
              {
                name: "debounce",
                rawName: "v-debounce:750ms",
                value: _vm.loadStories,
                expression: "loadStories",
                arg: "750ms"
              }
            ],
            attrs: { type: "text", placeholder: "Start typing..." },
            domProps: { value: _vm.payload.keyword },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.payload, "keyword", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "results" },
          _vm._l(_vm.stories, function(article) {
            return _c("article", { key: article.id }, [
              _c("a", { staticClass: "image", attrs: { href: article.url } }, [
                article.image !== null
                  ? _c("img", {
                      attrs: {
                        src: article.image,
                        alt: "Habit Health " + article.title
                      }
                    })
                  : _c("div", { staticClass: "backup" }, [
                      _c("img", {
                        attrs: {
                          src: "/images/logo-mark.svg",
                          alt: "Habit Health " + article.title
                        }
                      })
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("h3", [_vm._v(_vm._s(article.title))]),
                _vm._v(" "),
                _c("p", { staticClass: "date" }, [
                  _vm._v(_vm._s(article.published_date))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tags" },
                  [
                    _c("span", { staticClass: "icon icon-tag" }),
                    _vm._v(" "),
                    _vm._l(article.module_groups_items[0].items, function(
                      tag,
                      index
                    ) {
                      return _c("a", { attrs: { href: "?tag=" + tag.id } }, [
                        _vm._v("\n                " + _vm._s(tag.title)),
                        article.module_groups_items[0].items.length !==
                        index + 1
                          ? _c("i", [_vm._v(",")])
                          : _vm._e()
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _c("p", [_vm._v(_vm._s(article.blurb))])
                ])
              ])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-module" },
          [
            _vm.meta.total > 5
              ? _c("b-pagination", {
                  staticClass: "pagination",
                  attrs: {
                    "total-rows": _vm.meta.total,
                    "per-page": _vm.meta.per_page
                  },
                  on: {
                    input: function($event) {
                      return _vm.pageLoad(_vm.meta.current_page)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "first-text",
                        fn: function() {
                          return [
                            _c("span", { staticClass: "icon icon-angle-left" })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "page",
                        fn: function(ref) {
                          var page = ref.page
                          var active = ref.active
                          return [
                            _vm._v(
                              "\n            " + _vm._s(page) + "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "last-text",
                        fn: function() {
                          return [
                            _c("span", { staticClass: "icon icon-angle-right" })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1263074466
                  ),
                  model: {
                    value: _vm.meta.current_page,
                    callback: function($$v) {
                      _vm.$set(_vm.meta, "current_page", $$v)
                    },
                    expression: "meta.current_page"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a855a760", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a855a760","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/client-stories/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a855a760","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/client-stories/Index.vue
// module chunks = 0